import React, { useRef, useState, useEffect, useMemo} from 'react';
import { motion, useScroll, useTransform, useSpring} from 'framer-motion';
import './App.css';
import pinos from "./assets/bosque.png";

import GuiaTuristica from './views/guiaTuristica';
import ComoLlegar from './views/comoLlegar';
import DressCode from './views/dressCode';


import MapPath from './MapPath';
import WelcomeLetter from './views/WelcomeLetter';
import NuestraHistoria from './views/NuestraHistoria';
import MasDeUstedes from './views/masDeUstedes';
import Fiesta from './views/bailar';
import TuEstancia from './views/TuEstancia';
import MesaRegalos from './views/MesaRegalos';
import Footer from './views/Footer';

const App = () => {
 

  return (
    <div>
      <nav className='menu'>
      </nav>
     <WelcomeLetter></WelcomeLetter> 
      <NuestraHistoria></NuestraHistoria>
    <section className='detalles-evento' >
      <div className="header-seccion" >
          <h1 className='bold'>Detalles del evento</h1>
          <p className="text-md">Para nosotros, no hay mejor refugio que el aire frío y el susurro de las hojas en el viento <span style={{"font-style": "normal"}}>🍃</span>.<br/> Alista tu abrigo favorito y prepárate para adentrarte en el místico corazón del Parque Nacional El Chico, donde la naturaleza se siente viva en cada rincón y el frío del bosque hará más especial nuestro encuentro <span style={{"font-style": "normal"}}>🌲💙</span>.<br/><br/>Debajo encontrarán la ruta de nuestra celebración. Consulten en esta sección los horarios y eventos principales que darán vida a este día tan especial:</p>
      </div>
          <motion.img src={pinos} alt="" className="separador-pinos" 
                      initial={{ opacity: 0, y: 80 }} 
                      whileInView={{ opacity: 1, y: 0}}
                      transition={{ duration: 0.8 }} />
          
          <MapPath></MapPath>
          
    </section>
<section className="masDeUstedes">
      <MasDeUstedes></MasDeUstedes>
    </section>
    <section className="hospedaje">
          <TuEstancia></TuEstancia>
    </section>
    <section className="reservaciones">
    </section>
    <section className="guiaTuristica">
      <GuiaTuristica></GuiaTuristica>
    </section>
    <section className="como-llegar-seccion">
      <ComoLlegar></ComoLlegar>
    </section>
    <section className="dressCode">
      <DressCode></DressCode>
    </section>
    
    <section className="fiesta">
      <Fiesta></Fiesta>
    </section>
    <section >
      <MesaRegalos></MesaRegalos>
    </section>

    <section className="seccion-footer">
       
      <Footer></Footer>
     
    </section>
    </div>
  );
};

export default App;